import React from 'react'
import type { GetStaticPaths, GetStaticProps } from 'next'

import { isSlugAPageNumber } from '@marketing-sites/utils'
import type { ArticleIndexPageProps } from '../ArticleIndexPage'
import {
  ArticlesIndexPage,
  getStaticPathsForArticleIndexPage,
  getStaticPropsForArticleIndexPage,
} from '../ArticleIndexPage'

import type { ArticlePageProps } from '../ArticlePage'
import {
  ArticlePage,
  getStaticPathsForArticlePage,
  getStaticPropsForArticlePage,
} from '../ArticlePage'

export type ArticlesIndexPageOrArticlePageProps =
  | ArticleIndexPageProps
  | ArticlePageProps

export function ArticlesIndexPageOrArticlePage(
  props: ArticlesIndexPageOrArticlePageProps,
) {
  if (props.kind === 'ArticleIndexPageProps') {
    return <ArticlesIndexPage {...props} />
  }
  return <ArticlePage {...props} />
}

export const getStaticPathsForArticleIndexPagesAndArticlePages: GetStaticPaths =
  async (context) => {
    const articleIndexPagePaths =
      await getStaticPathsForArticleIndexPage(context)
    const articlePagePaths = await getStaticPathsForArticlePage(context)

    const result = {
      paths: [...articleIndexPagePaths.paths, ...articlePagePaths.paths],
      fallback: false,
    }
    return result
  }

export const getStaticPropsForArticleIndexPageOrArticlePage: GetStaticProps<
  ArticlesIndexPageOrArticlePageProps
> = async (context) => {
  const { params } = context
  if (isSlugAPageNumber(params?.['slug'])) {
    const result = await getStaticPropsForArticleIndexPage(context)
    return result
  }
  const result = await getStaticPropsForArticlePage(context)
  return result
}
